'use strict';

angular.module('schoolLinqApp').factory('employeeService', [
	'$http',

	function ($http) {
		var endpoint = '/api/employee';

		// EndpointEnum: ReadEmployees
		function list() {
			return $http.get(endpoint + '/list');
		}

		function getForDropdowns() {
			return $http.get(endpoint + '/for-dropdowns');
		}

		// EndpointEnum: ReadEmployeesFiltered
		function search(filter) {
			return $http.get(endpoint + '/search', {
				params: {
					statusId: filter.statusId,
					name: filter.name,
					number: filter.number,
					siteId: filter.siteId,
					jobId: filter.jobId,
					payGroupId: filter.payGroupId,
				},
			});
		}

		function getNextEmployeeNumber() {
			return $http.get(endpoint + '/nextEmployeeNumber');
		}

		function canGenerateEmployeeNumber() {
			return $http.get(endpoint + '/canGenerateEmployeeNumber');
		}

		// EndpointEnum: ReadEmployeeById
		function get(Id) {
			return $http.get(endpoint, { params: { Id: Id } });
		}

		// EndpointEnum: UpdateEmployee
		function update(employee) {
			return $http.post(endpoint, employee);
		}

		// EndpointEnum: CreateEmployee
		function add(employee) {
			return $http.put(endpoint, employee);
		}

		// EndpointEnum: DeleteEmployee
		function deleteEmployee(Id) {
			return $http.delete(endpoint, { params: { Id: Id } });
		}

		// EndpointEnum: UpdateEmployee
		function setEmployeeDirectDepositBankIsValid(employeeDirectDepositId, isValid) {
			return $http.post(endpoint + '/setEmployeeDirectDepositBankIsValid', {
				EmployeeDirectDepositId: employeeDirectDepositId,
				IsValid: isValid,
			});
		}

		function getEmployeeEligibleDeductions(employeeId) {
			return $http.get(endpoint + '/getEmployeeEligibleDeductions', {
				params: { employeeId: employeeId },
			});
		}

		function getEmployeeDeductionPaidToDateAmount(employeeId, employeeDeductionId) {
			return $http.get(endpoint + '/getEmployeeDeductionPaidToDateAmount', {
				params: {
					employeeId: employeeId,
					employeeDeductionId: employeeDeductionId,
				},
			});
		}

		function getEmployeeTDPAgreements(employeeId) {
			return $http.get(endpoint + '/getEmployeeTDPAgreements', {
				params: { employeeId: employeeId },
			});
		}

		// EndpointEnum: UpdateEmployee
		function evaluateSubjectToRetirements(employeeId) {
			return $http.get(endpoint + '/evaluateSubjectToRetirements', {
				params: { employeeId: employeeId },
			});
		}

		// EndpointEnum: UpdateEmployee
		function saveEmployeeTDPAgreement(agreement) {
			return $http.post(endpoint + '/saveEmployeeTDPAgreement', agreement);
		}

		// EndpointEnum: UpdateEmployee
		function deleteEmployeeTDPAgreement(agreementId) {
			return $http.delete(endpoint + '/deleteEmployeeTDPAgreement', {
				params: { agreementId: agreementId },
			});
		}

		function getEmployeeCheckYears(employeeId) {
			return $http.get(endpoint + '/getEmployeeCheckYears', {
				params: { employeeId: employeeId },
			});
		}

		// EndpointEnum: ReadEmployeeCheckListing
		function getEmployeeCheckListing(employeeId, startDate, endDate) {
			return $http.get(endpoint + '/getEmployeeCheckListing', {
				params: {
					employeeID: employeeId,
					startDate: startDate,
					endDate: endDate,
				},
			});
		}

		function getEmployeeCheckDetails(checkNumber, employeeId, checkDT) {
			return $http.get(endpoint + '/getEmployeeCheckDetails', {
				params: {
					checkNumber: checkNumber,
					employeeId: employeeId,
					checkDT: checkDT,
				},
			});
		}

		// EndpointEnum: ReadEmployeeCheckSummary
		function getEmployeeCheckSummary(employeeId, startDate, endDate) {
			return $http.get(endpoint + '/getEmployeeCheckSummary', {
				params: {
					employeeID: employeeId,
					startDate: startDate,
					endDate: endDate,
				},
			});
		}

		function getEmployeeLeaveSummary(employeeId, onlyLatestYear) {
			if (!onlyLatestYear) {
				onlyLatestYear = false;
			}
			return $http.get(endpoint + '/getEmployeeLeaveSummary', {
				params: { employeeId: employeeId, onlyLatestYear: onlyLatestYear },
			});
		}

		function getEmployeeLeaveDetail(employeeId, fiscalYear, leaveId) {
			return $http.get(endpoint + '/getEmployeeLeaveDetail', {
				params: { employeeId: employeeId, fiscalYear: fiscalYear, leaveId: leaveId },
			});
		}

		function getEmployeeLeaveBalances(leaveId, activeJobsOnly, asOfDate) {
			return $http.get(endpoint + '/getEmployeeLeaveBalances', {
				params: {
					leaveId: leaveId,
					activeJobsOnly: activeJobsOnly,
					asOfDate: asOfDate,
				},
			});
		}

		// EndpointEnum: UpdateEmployeeLeaveBalance
		function adjustEmployeeLeaveBalances(leaveBalanceModel) {
			return $http.put(endpoint + '/adjustEmployeeLeaveBalances', leaveBalanceModel);
		}

		// EndpointEnum: UpdateEmployee
		function addDeductionAdjustment(deductionAdjustments) {
			return $http.post(endpoint + '/deductions-adjustment', deductionAdjustments);
		}

		function getDatesOfService(employeeId, year, isFiscal) {
			return $http.get(endpoint + '/getDatesOfService', {
				params: { employeeId: employeeId },
			});
		}

		// EndpointEnum: UpdateEmployee
		function saveDatesOfService(datesOfService, employeeId) {
			if (!employeeId) {
				throw new Error('EmployeeId needs to be provided to save dates of service');
			}

			return $http.put(endpoint + '/saveDatesOfService', datesOfService, { params: { employeeId: employeeId.toString() } });
		}

		// EndpointEnum: UpdateEmployee
		function addEarningsAdjustment(earningsAdjustments) {
			return $http.post(endpoint + '/earnings-adjustment', earningsAdjustments);
		}

		// EndpointEnum: UpdateEmployee
		function addFringeBenefit(fringeBenefitModel) {
			return $http.post(endpoint + '/fringe-benefit-adjustment', fringeBenefitModel);
		}

		function getEmployeeDeductionsAndWithholdings(employeeId) {
			return $http.get(endpoint + '/getEmployeeDeductionsAndWithholdings', {
				params: { employeeId: employeeId },
			});
		}

		function getUIDStaffList(month, year) {
			return $http.get(endpoint + '/getUIDStaffList', {
				params: { month: month, year: year },
			});
		}

		// EndpointEnum: UpdateStaffUID
		function updateStaffUID(uidImport, ignoreUnitCheck) {
			return $http.post(endpoint + `/updateStaffUID?ignoreUnitCheck=${ignoreUnitCheck}`, uidImport);
		}

		// EndpointEnum: UpdateRetirementNumbers
		function updateRetirementNumbers(orbitImport) {
			return $http.post(endpoint + '/updateRetirementNumbers', orbitImport);
		}

		function getCheckHistoryPayPeriods(employeeJobId) {
			return $http.get(endpoint + '/getCheckHistoryPayPeriods', {
				params: { employeeJobId: employeeJobId },
			});
		}

		function getDDAccounts() {
			return $http.get(endpoint + '/getDDAccounts');
		}

		function getSickPayAdjustments(year, quarter) {
			return $http.post(endpoint + '/getSickPayAdjustments', {
				Year: year,
				Quarter: quarter,
			});
		}

		function getEmployeeRetirementDeductions(employeeId) {
			return $http.get(endpoint + '/getEmployeeRetirementDeductions', {
				params: { employeeId: employeeId },
			});
		}
		// EndpointEnum: ReadEmployeeById
		function getManageEmployeeDemographics(employeeId) {
			return $http.get(endpoint + '/getManageEmployeeDemographics', {
				params: { Id: employeeId },
			});
		}
		// EndpointEnum: ReadEmployeeById
		function getManageEmployeeJobs(employeeId) {
			return $http.get(endpoint + '/getManageEmployeeJobs', {
				params: { Id: employeeId },
			});
		}

		function printReclassifyDetailsReport(batchId, checkId) {
			return $http.post('/api/reclassify-batches/details-report', {
				batchId,
				checkId,
			});
		}

		return {
			list: list,
			getForDropdowns: getForDropdowns,
			search: search,
			getNextEmployeeNumber: getNextEmployeeNumber,
			canGenerateEmployeeNumber: canGenerateEmployeeNumber,
			get: get,
			update: update,
			add: add,
			getManageEmployeeDemographics: getManageEmployeeDemographics,
			getManageEmployeeJobs: getManageEmployeeJobs,
			deleteEmployee: deleteEmployee,
			setEmployeeDirectDepositBankIsValid: setEmployeeDirectDepositBankIsValid,
			getEmployeeEligibleDeductions: getEmployeeEligibleDeductions,
			getEmployeeDeductionPaidToDateAmount: getEmployeeDeductionPaidToDateAmount,
			getEmployeeTDPAgreements: getEmployeeTDPAgreements,
			saveEmployeeTDPAgreement: saveEmployeeTDPAgreement,
			deleteEmployeeTDPAgreement: deleteEmployeeTDPAgreement,
			getEmployeeCheckYears: getEmployeeCheckYears,
			getEmployeeCheckListing: getEmployeeCheckListing,
			getEmployeeLeaveSummary: getEmployeeLeaveSummary,
			getEmployeeLeaveDetail: getEmployeeLeaveDetail,
			getEmployeeLeaveBalances: getEmployeeLeaveBalances,
			adjustEmployeeLeaveBalances: adjustEmployeeLeaveBalances,
			getEmployeeCheckSummary: getEmployeeCheckSummary,
			addDeductionAdjustment: addDeductionAdjustment,
			getDatesOfService: getDatesOfService,
			saveDatesOfService: saveDatesOfService,
			addEarningsAdjustment: addEarningsAdjustment,
			addFringeBenefit: addFringeBenefit,
			getEmployeeDeductionsAndWithholdings: getEmployeeDeductionsAndWithholdings,
			getUIDStaffList: getUIDStaffList,
			updateStaffUID: updateStaffUID,
			updateRetirementNumbers: updateRetirementNumbers,
			getCheckHistoryPayPeriods: getCheckHistoryPayPeriods,
			getDDAccounts: getDDAccounts,
			getSickPayAdjustments: getSickPayAdjustments,
			getEmployeeRetirementDeductions: getEmployeeRetirementDeductions,
			evaluateSubjectToRetirements: evaluateSubjectToRetirements,
			printReclassifyDetailsReport: printReclassifyDetailsReport,
			getEmployeeCheckDetails: getEmployeeCheckDetails,
		};
	},
]);
